// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqHomepageSection_container__gA6h0","listWrapper":"FaqHomepageSection_listWrapper__5Gga1","faqList":"FaqHomepageSection_faqList__5Ahjf"};